function mapProps(props, map) {
  var _a, _b, _c, _d, _e, _f, _g;
  const requiredProps = {
    name: props.name,
    value: props.value,
    required: props.required,
    onChange: props.onChange
  };
  if (map === "GlInput.v3") {
    return {
      ...requiredProps,
      min: (_a = props.min) == null ? void 0 : _a.toString(),
      max: (_b = props.max) == null ? void 0 : _b.toString(),
      disabled: props.disabled,
      valid: props.valid,
      onBlur: props.onBlur,
      hint: (_c = props.error) == null ? void 0 : _c.message
    };
  } else if (map === "GlInput.v5") {
    return {
      ...requiredProps,
      min: (_d = props.min) == null ? void 0 : _d.toString(),
      max: (_e = props.max) == null ? void 0 : _e.toString(),
      disabled: props.disabled,
      valid: props.valid,
      onBlur: props.onBlur,
      errorText: (_f = props.error) == null ? void 0 : _f.message
    };
  } else if (map === "GlCheckbox.v5") {
    return {
      ...requiredProps,
      isChecked: props.value,
      success: props.valid === true ? true : void 0,
      error: props.valid === false ? true : void 0,
      errorText: (_g = props.error) == null ? void 0 : _g.message
    };
  } else {
    return {
      ...requiredProps,
      ...map(props)
    };
  }
}
export {
  mapProps
};
//# sourceMappingURL=props-mapper.js.map
